import React from 'react';
import { Col, Input, Row, FormGroup, Label } from 'reactstrap';

const DeviceBox = ({device, deviceCheckboxHandler}) => {

  return(
    <Row className='device-check mb-3'>
      <Col xs={10} className='pe-0'>
        <div className="d-flex align-items-start mb-2">
          <img className="me-2 device-img" src={device.productImageUrl} alt='' />
          <h5>{device.name}</h5>
        </div>
        <p className='mb-3'>{device.description}</p>
      </Col>
      <Col xs={2} className='text-center'>
        <FormGroup check>
          <Label check>
            <Input type="checkbox" value={device.productId} onChange={deviceCheckboxHandler}  />
          </Label>
        </FormGroup>
      </Col>
    </Row>
  );
}

export default DeviceBox;